var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"J-weixin-tip weixin-tip"},[_c('div',{staticClass:"weixin-tip-content"},[_vm._v(" 请在菜单中选择在浏览器中打开,"),_c('br'),_vm._v(" 以完成支付 ")])]),_c('div',{staticClass:"J-weixin-tip-img weixin-tip-img"})])
}]

export { render, staticRenderFns }